import { render, staticRenderFns } from "./sensorDataCard.vue?vue&type=template&id=7f5da12b&scoped=true"
import script from "./sensorDataCard.vue?vue&type=script&lang=js"
export * from "./sensorDataCard.vue?vue&type=script&lang=js"
import style0 from "./sensorDataCard.vue?vue&type=style&index=0&id=7f5da12b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f5da12b",
  null
  
)

export default component.exports